import { getCountryFromLanguage } from '../Intl/IntlHelper.js';

// Consumer payment methods surfaced per country, based on Stripe's
// payment-method country support:
// https://docs.stripe.com/payments/payment-methods/payment-method-support
//
// Notes:
// - giropay & Sofort are excluded (deprecated / removed by Stripe).
// - Bancontact is Belgium-only, so it maps to no enabled locale.
// - iDEAL is Netherlands-only; Cartes Bancaires (CB) is the French card scheme.
// - Cards / PayPal / Klarna / Apple Pay / Google Pay are available in every
//   supported country.
//
// Tile logos live in assets/images/payments/tiles/{key}.{webp,png}

export const PAYMENT_METHOD_LABELS = {
    cb: 'Cartes Bancaires',
    visa: 'Visa',
    mastercard: 'Mastercard',
    // amex: 'American Express',
    ideal: 'iDEAL',
    paypal: 'PayPal',
    klarna: 'Klarna',
    applepay: 'Apple Pay',
    googlepay: 'Google Pay',
};

// Available to customers in every supported country.
const COMMON = ['visa', 'mastercard', 'paypal', 'klarna', 'applepay', 'googlepay'];

// Country-specific methods, prepended for prominence (customer country).
const BY_COUNTRY = {
    FR: ['cb', ...COMMON], // Cartes Bancaires
    NL: ['ideal', ...COMMON], // iDEAL
    // GB, DE, IT, ES fall back to COMMON
};

export function getPaymentMethodsForLocale(locale) {
    const country = getCountryFromLanguage(locale);
    return BY_COUNTRY[country] || COMMON;
}
